// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Waa-z","narrowOptionButtons":"Xaa-z","noOptions":"Yaa-z"};